import { Patient } from "../../types/healthcare/PatientTypes";

export const getPatientDataSnapshot = (patient: Patient): string =>
	JSON.stringify({
		medical_history: patient.medical_history || [],
		medications: patient.medications || [],
		tests: patient.tests || [],
	});
